<template>
    <b-card>
        <b-card-title>
            <h3>{{titulo}}</h3>
        </b-card-title>
        <b-card-text>
            <b-row>
                <b-col class="text-left"><span><b>Direcc. Distrital:</b> {{planilla[1].distrito}}</span></b-col>
                <b-col><h4>NIVEL SECUNDARIO</h4></b-col>
                <b-col><span><b>Grado:</b> {{planilla[2].nombre}}</span></b-col>
            </b-row>
            <b-row class="mb-3">
                <b-col class="text-left"><span><b>Unidad Educativa:</b> {{planilla[1].nombre}}</span></b-col>
                <b-col><h4>{{planilla[0].gestion}}</h4></b-col>
                <b-col><span><b>Turno:</b> {{planilla[1].turno}}</span></b-col>
            </b-row>
        </b-card-text>
    </b-card>    
</template>
<script>
import {mapState} from 'vuex'
export default {
    name: 'CabeceraPlanilla',
    props: {
        titulo: ''
    },
    computed: {
        ...mapState(['planilla'])
    }
}
</script>

<style scoped lang="scss">
/deep/ span {
    font-size: 18px;
}
</style>